import { LineStroke, LineWidth } from "@nova/constants"
import * as Icons from "@nova/component-icons"

export const thicknesses: Record<LineWidth, Icons.IconComponent> = {
    [LineWidth.none]: Icons.LineThicknessNone,
    [LineWidth.normal]: Icons.LineWeightThin,
    [LineWidth.thick]: Icons.LineWeightThick,
}

export const iconByWidth: [LineWidth, Icons.IconComponent][] = Object.entries(thicknesses).map(
    ([width, icon]) => [Number(width) as LineWidth, icon]
)

export const patterns: Record<LineStroke, Icons.IconComponent> = {
    [LineStroke.normal]: Icons.LineNormal,
    [LineStroke.dashed]: Icons.LineDashed,
    [LineStroke.dotted]: Icons.LineDotted,
    [LineStroke.squared]: Icons.LineSquared,
}

export const iconByStrokeType: [LineStroke, Icons.IconComponent][] = Object.entries(patterns).map(
    ([strokeType, icon]) => [Number(strokeType) as LineStroke, icon]
)
